import Image from 'next/image';
import Link from 'next/link';

import HeaderLogo from '@/assets/images/mlp/mlp-header-logo.svg';

const CommonMlpHeader = () => {
  return (
    <nav
      className={`mainNav navbar fixed-top navbar-expand-lg bg-scroll`}
      // style={{ position: 'relative', top: '0%', fontFamily: 'Helvetica' }}
    >
      <div className="c-mlp-header container">
        <div className="nav-right">
          <Link className="navbar-brand" href="/" id="mlp_muthoot-logo">
            <Image
              style={{ color: undefined }}
              className="img-fluid mfo-logo-header"
              src={HeaderLogo}
              alt="Muthoot Logo"
            />
            <span className="sr-only">Muthoot Logo</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default CommonMlpHeader;
